import classNames from 'classnames';
import React from 'react';
import type { DSTTransitionDetails } from 'utils/date-helper';
import { pixelsToTimeFormat, removeAmPmSuffix } from 'utils/time-helper';
import styles from './ClickDragAdjust.module.scss';

interface Props {
  pixelsPerMinute: number;
  pxToCurrentDayTop: number;
  isSelecting: boolean;
  timeFormat: 12 | 24;
  direction: 'top' | 'bottom';
  showFromToLabels: boolean;
  DSTTransitionDetails: DSTTransitionDetails;
}

export function AdjustResizeHandle(props: Props) {
  const {
    pxToCurrentDayTop,
    isSelecting,
    pixelsPerMinute,
    direction,
    showFromToLabels = false,
    timeFormat = 24,
    DSTTransitionDetails,
  } = props;

  const className = classNames(styles.resizeHandle, {
    [styles.isActive]: isSelecting,
    [styles.directionTop]: direction === 'top',
    [styles.directionBottom]: direction === 'bottom',
  });

  const fromToLabel = pixelsToTimeFormat(pxToCurrentDayTop, {
    pixelsPerMinute,
    timeFormat,
    DSTTransitionDetails,
  });
  const formattedLabel = removeAmPmSuffix(fromToLabel, timeFormat);

  return (
    <div className={className}>
      <div className={styles.handle}>
        <div className={styles.handleKnob} />
      </div>
      {showFromToLabels && <small>{formattedLabel}</small>}
    </div>
  );
}
